/*
 * Cork Haven — Atlantic crossing map
 *
 * Dot-matrix land mask of the whole shipping route: Gulf of Mexico and the
 * Florida peninsula on the left, Iberia and northwest Africa on the right,
 * open Atlantic between. The great circle from the Alentejo cork forests to
 * the Madison warehouse arcs north across the gap.
 *
 * Frame is lon -100..0, lat 14..50 on an equirectangular projection with a
 * standard parallel at 35N, so the horizontal scale is cos(35). Without that
 * correction the landmasses come out smeared wide. The mask is a 437x192
 * grid packed 6 bits per base64 char, precomputed from Natural Earth 50m
 * land polygons. ~14KB ships, versus the 4K .mov this hero replaced.
 *
 * The southern edge runs to 14N rather than stopping at the Tropic. That is
 * not extra geography for its own sake: at 2.28:1 the frame is tall enough to
 * reach the bottom of the hero band on a wide screen, so the map runs under
 * the copy instead of ending in a blank strip above the section border.
 *
 * Composition rule that drives the rest of the file: the copy block sits in
 * the lower-middle ocean, centred, capped at 42% of the band. Everything here
 * is placed to stay out of it, and both endpoint labels hug the outer edges.
 *
 * When the shipment lands at Madison the country fans out from it — one ray
 * per state, on true bearings. Fifteen state centroids are west or north of
 * this frame; those rays dissolve at the edge rather than being clipped. See
 * the block above drawFan.
 *
 * Progressive enhancement: the section renders complete without this file.
 * The canvas is aria-hidden and the route is also stated in text.
 */
(function () {
  'use strict';

  var PACKED = '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';

  var GRID = { lonMin: -100, lonMax: 0, latMin: 14, latMax: 50, phi0: 35, cols: 437, rows: 192 };

  var RAD = Math.PI / 180;
  var K = Math.cos(GRID.phi0 * RAD);
  var PROJ_W = (GRID.lonMax - GRID.lonMin) * K;
  var PROJ_H = GRID.latMax - GRID.latMin;

  var B64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  function decode(packed, count) {
    var bits = new Uint8Array(count), i = 0, c, v, b;
    for (c = 0; c < packed.length; c++) {
      v = B64.indexOf(packed.charAt(c));
      if (v < 0) continue;
      for (b = 5; b >= 0; b--) if (i < count) bits[i++] = (v >> b) & 1;
    }
    return bits;
  }

  var LAND = decode(PACKED, GRID.cols * GRID.rows);

  /* Great-circle interpolation via slerp on unit vectors, so the line leaves
     Portugal on the true bearing for Florida rather than an invented curve. */
  function greatCircle(a, b, steps) {
    var p1 = a.lat * RAD, l1 = a.lon * RAD;
    var p2 = b.lat * RAD, l2 = b.lon * RAD;
    var d = Math.acos(Math.min(1, Math.max(-1,
      Math.sin(p1) * Math.sin(p2) + Math.cos(p1) * Math.cos(p2) * Math.cos(l2 - l1))));
    if (!d) return [{ lon: a.lon, lat: a.lat }];
    var pts = [], i, f, A, B, x, y, z;
    for (i = 0; i <= steps; i++) {
      f = i / steps;
      A = Math.sin((1 - f) * d) / Math.sin(d);
      B = Math.sin(f * d) / Math.sin(d);
      x = A * Math.cos(p1) * Math.cos(l1) + B * Math.cos(p2) * Math.cos(l2);
      y = A * Math.cos(p1) * Math.sin(l1) + B * Math.cos(p2) * Math.sin(l2);
      z = A * Math.sin(p1) + B * Math.sin(p2);
      pts.push({
        lat: Math.atan2(z, Math.sqrt(x * x + y * y)) / RAD,
        lon: Math.atan2(y, x) / RAD
      });
    }
    return pts;
  }

  /* The central angle on its own. greatCircle() computes this internally but
     does not hand it back, and the fan-out needs it per ray to run every head
     at the same speed over the ground. */
  function gcAngle(a, b) {
    var p1 = a.lat * RAD, l1 = a.lon * RAD;
    var p2 = b.lat * RAD, l2 = b.lon * RAD;
    return Math.acos(Math.min(1, Math.max(-1,
      Math.sin(p1) * Math.sin(p2) + Math.cos(p1) * Math.cos(p2) * Math.cos(l2 - l1))));
  }

  function rgb(hex, fallback) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n) || h.length !== 6) return fallback;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function rgba(c, a) {
    return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')';
  }

  /* Cork oak grove =========================================================
     A montado — the spaced cork oak savanna of the Alentejo — along the foot
     of the band. Not decoration: it is the tree the entire business is built
     on, so it is drawn to the species rather than as generic foliage.

     Quercus suber reads as: a crown far broader than it is tall, a short
     trunk that forks low into a few heavy limbs, and — the detail that makes
     it a *cork* oak rather than any oak — the harvest line, the clean
     horizontal mark where the bark has been stripped off the lower trunk.
     That last one is why these are worth drawing at all.

     Depth is carried by material, not by blur: distant trees are dots on the
     same lattice as the map, near trees are solid. The grove resolves out of
     the map rather than sitting on top of it. */

  // Seeded, so the grove is identical on every load and every resize. A grove
  // that reshuffles when you turn your phone reads as a bug.
  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  /* Local coords: origin at the base of the trunk, y counted upward.

     The crown is one closed outline whose radius is modulated by a few sine
     harmonics, not a pile of overlapping ellipses. That distinction is the
     whole difference between a tree and a cloud: circle unions bulge outward
     in arcs and the eye reads them as bubbles, while a noise-perturbed radius
     gives the irregular, slightly ragged edge that reads as foliage. A few
     sky-holes are punched near the rim for the same reason — light coming
     through the canopy is most of what tells you it is a tree. */
  function corkOak(rnd, h) {
    function rr(a, b) { return a + rnd() * (b - a); }
    var i;

    var crownW = h * rr(1.12, 1.44);        // broader than tall — the giveaway
    var crownBottom = h * rr(0.26, 0.38);   // clear trunk under it
    var crownH = h - crownBottom;
    var lean = rr(-0.05, 0.05) * h;

    var cx = lean;
    var cy = crownBottom + crownH * 0.5;
    var rx = crownW * 0.5;
    var ry = crownH * 0.5;

    // Five octaves. The low ones give the crown its overall lopsidedness, the
    // high ones the frayed edge — without those last two it comes out as a
    // smooth pebble no matter how much you perturb the big harmonics.
    var N = 160;
    var prof = new Float32Array(N);
    var ph = [rr(0, 6.2832), rr(0, 6.2832), rr(0, 6.2832), rr(0, 6.2832), rr(0, 6.2832)];
    var am = [rr(0.09, 0.14), rr(0.05, 0.09), rr(0.035, 0.06), rr(0.022, 0.042), rr(0.014, 0.028)];
    var kk = [3, 5, 9, 15, 23];
    for (i = 0; i < N; i++) {
      var th = i / N * 6.2832;
      var v = 1;
      for (var o = 0; o < 5; o++) v += am[o] * Math.sin(kk[o] * th + ph[o]);
      prof[i] = v;
    }
    var crown = { cx: cx, cy: cy, rx: rx, ry: ry, prof: prof, n: N };

    /* Sky-holes, kept to the outer half of the crown where they read. More of
       them and smaller than you would guess: a few large ones punch as holes
       and the crown reads as swiss cheese, where several small ones read as
       light coming through. */
    var holes = [];
    var nh = 4 + Math.floor(rnd() * 4);
    for (i = 0; i < nh; i++) {
      var ht = rnd() * 6.2832;
      var hr = rr(0.42, 0.80);
      holes.push({
        x: cx + Math.cos(ht) * rx * hr,
        y: cy + Math.sin(ht) * ry * hr,
        rx: h * rr(0.020, 0.046),
        ry: h * rr(0.016, 0.034)
      });
    }

    // Trunk, then a low fork. Cork oaks branch close to the ground; the part
    // of the fork below the crown edge gives the wide-shouldered stance.
    var trunkW = h * rr(0.055, 0.082);
    var forkY = crownBottom * rr(0.42, 0.62);
    var limbs = [{
      x1: 0, y1: -h * 0.05, x2: lean * 0.6, y2: forkY,
      w1: trunkW * 1.15, w2: trunkW * 0.92
    }];

    var nl = 2 + (rnd() < 0.5 ? 0 : 1);
    for (i = 0; i < nl; i++) {
      var f = nl === 1 ? 0.5 : i / (nl - 1);
      var ang = (-0.78 + 1.56 * f) + rr(-0.16, 0.16);
      var len = (cy - forkY) * rr(0.85, 1.15);
      limbs.push({
        x1: lean * 0.6, y1: forkY,
        x2: lean * 0.6 + Math.sin(ang) * len * 1.05,
        y2: forkY + Math.cos(ang) * len,
        w1: trunkW * 0.78, w2: trunkW * 0.3
      });
    }

    return {
      h: h,
      crownW: crownW * 1.3,   // generous, the profile can push past rx
      crown: crown,
      holes: holes,
      limbs: limbs,
      harvestY: forkY * rr(0.62, 0.86)
    };
  }

  function inCrown(cr, x, y) {
    var dx = (x - cr.cx) / cr.rx, dy = (y - cr.cy) / cr.ry;
    var r = Math.sqrt(dx * dx + dy * dy);
    if (r > 1.35) return false;
    var th = Math.atan2(dy, dx);
    if (th < 0) th += 6.2832;
    var f = th / 6.2832 * cr.n;
    var i0 = Math.floor(f) % cr.n;
    var t = f - Math.floor(f);
    return r <= cr.prof[i0] * (1 - t) + cr.prof[(i0 + 1) % cr.n] * t;
  }

  function inCapsule(s, x, y) {
    var vx = s.x2 - s.x1, vy = s.y2 - s.y1;
    var L2 = vx * vx + vy * vy;
    var t = L2 ? ((x - s.x1) * vx + (y - s.y1) * vy) / L2 : 0;
    if (t < 0) t = 0; else if (t > 1) t = 1;
    var dx = x - (s.x1 + vx * t), dy = y - (s.y1 + vy * t);
    var w = (s.w1 + (s.w2 - s.w1) * t) * 0.5;
    return dx * dx + dy * dy <= w * w;
  }

  function inTree(tree, x, y) {
    var i, b, dx, dy;
    for (i = 0; i < tree.limbs.length; i++) {
      if (inCapsule(tree.limbs[i], x, y)) return true;
    }
    if (!inCrown(tree.crown, x, y)) return false;
    for (i = 0; i < tree.holes.length; i++) {
      b = tree.holes[i];
      dx = (x - b.x) / b.rx; dy = (y - b.y) / b.ry;
      if (dx * dx + dy * dy <= 1) return false;
    }
    return true;
  }

  // Tallest tree a rank can produce, as a fraction of the grove unit. Ranks
  // scatter within a range; the front plane carries an explicit list.
  function tallest(rank) {
    return rank.hAt ? Math.max.apply(null, rank.hAt) : rank.hMax;
  }

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The cursor field -------------------------------------------------------
     The hero is already a dot field — twenty thousand of them on a fixed
     lattice — so the pointer does not get its own layer of decoration. It
     disturbs the map's own dots, and it uncovers the lattice in the ocean,
     where the same grid exists but has nothing on it to draw.

     Uncovering rather than laying down a permanent grid is the whole trick.
     A dot field across the open Atlantic is a scrim by another name, and a
     scrim over the lower half dims the Florida peninsula, which is the one
     thing this hero exists to show. At rest the ocean stays bare page. The
     grid only exists where the pointer is, and only while it is moving.

     Displacement is computed straight from distance rather than integrated
     per dot. Dots outside the radius are not simulated at all — they come
     from the baked layer, at their anchors — so any per-dot spring state
     would pop the moment a dot left the radius. The lag that a spring buys
     is bought here by trailing the cursor itself, which costs nothing and
     cannot desynchronise. */
  var FIELD_R = 255;          // px. Radius of the disturbance.
  var FIELD_PUSH = 34;        // px. Displacement of a dot at the centre.
  var FIELD_REVEAL = 0.56;    // Peak alpha of an uncovered ocean dot.
  var FIELD_BOOST = 0.26;     // Extra alpha on land dots under the pointer.
  /* Alpha quantisation. This is what the live pass costs against the baked
     layer it replaces inside the disc: at 24 levels the two agree to a mean
     of ~1% alpha, which is under the noise of dot-edge antialiasing and well
     under anything visible as the field fades in and out. */
  var FIELD_BUCKETS = 24;

  /* The uncovered field is drawn on every third lattice point, not every one.
     The map's own pitch is about 4px — fine enough to read as continuous
     halftone, which is right for a coastline and wrong for this. At that
     pitch a displaced dot moves seven times its own spacing and the bulge
     comes out as ring moiré: you see interference, not dots. Every third
     point is a ~13px grid, coarse enough that you watch individual dots move,
     which is the entire effect. It is also ten times fewer of them. */
  var FIELD_STEP = 3;

  function CorkMap(root) {
    this.root = root;
    this.canvas = root.querySelector('.cork-map__canvas');
    if (!this.canvas) return;
    this.ctx = this.canvas.getContext('2d');

    this.origin = { lat: parseFloat(root.dataset.originLat), lon: parseFloat(root.dataset.originLon) };
    this.dest = { lat: parseFloat(root.dataset.destLat), lon: parseFloat(root.dataset.destLon) };
    if (isNaN(this.origin.lat) || isNaN(this.origin.lon) ||
        isNaN(this.dest.lat) || isNaN(this.dest.lon)) return;

    this.dotColor = rgb(root.dataset.dotColor, [19, 78, 55]);
    this.arcColor = rgb(root.dataset.arcColor, [184, 134, 11]);

    /* Field dots are quantised into a fixed set of tones so a frame is a
       handful of filled paths rather than seven thousand fillStyle strings. */
    this.fieldColor = [];
    for (var q = 0; q < FIELD_BUCKETS; q++) {
      this.fieldColor.push(rgba(this.dotColor, ((q + 0.5) * 0.96 / FIELD_BUCKETS).toFixed(3)));
    }

    this.route = greatCircle(this.origin, this.dest, 400);

    /* Fan-out rays, built once in lat/lon and projected per frame. `ang` is
       the great-circle central angle, which is what the heads advance along.
       See the block above drawFan for why that matters. */
    this.fan = [];
    this.fanMax = 0;
    for (var s = 0; s < STATES.length; s++) {
      var target = { lat: STATES[s][0], lon: STATES[s][1] };
      var ang = gcAngle(this.dest, target);
      if (!(ang > 1e-5)) continue;
      this.fan.push({ pts: greatCircle(this.dest, target, FAN_STEPS), ang: ang });

      /* Pace the burst off the states that are actually in the frame. Hawaii
         is 1.15rad from Madison and Alaska 0.85 against 0.31 for the farthest
         in-frame state, so normalising on the true maximum would land the
         whole visible country in the first quarter of the burst and spend the
         rest on two heads that left the frame long ago. Off-frame rays simply
         never reach their endpoint — they dissolve at the edge, which is what
         they should do anyway. The test is against GRID, not against the
         canvas, so it does not move when the viewport does. */
      if (target.lon >= GRID.lonMin && target.lon <= GRID.lonMax &&
          target.lat >= GRID.latMin && target.lat <= GRID.latMax &&
          ang > this.fanMax) this.fanMax = ang;
    }
    this.fanColor = [];
    for (var fq = 0; fq < FAN_BUCKETS; fq++) {
      this.fanColor.push(rgba(this.arcColor, ((fq + 0.5) / FAN_BUCKETS).toFixed(3)));
    }
    this.fanSeg = [];
    this.fanDot = [];
    this.fanRing = [];
    for (var fb = 0; fb < FAN_BUCKETS; fb++) {
      this.fanSeg.push([]); this.fanDot.push([]); this.fanRing.push([]);
    }

    // Draw-in and the looping pulse run off one clock but are separate
    // stages: the route draws once, then the shipment repeats while visible.
    this.progress = reduceMotion ? 1 : 0;
    this.pulse = 0;
    this.burst = 0;
    this.tNow = 0;
    this.started = false;
    this.visible = false;
    this.raf = 0;

    /* Cursor field. `x/y` trail behind `tx/ty` so the bulge lags the pointer;
       `engage` is the smoothed pointer speed and gates the whole effect. */
    this.cursor = { x: 0, y: 0, tx: -9999, ty: -9999, lx: -9999, ly: -9999,
                    speed: 0, engage: 0, on: false, seen: false };
    this.bucket = [];
    for (var b = 0; b < FIELD_BUCKETS; b++) this.bucket.push([]);

    this.writeCoords();
    this.resize();
    this.observe();

    var self = this;
    this.onResize = function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () { self.resize(); }, 120);
    };
    window.addEventListener('resize', this.onResize);
    this.watchPointer();

    // The route clearance is measured off the rendered copy block, so it has
    // to be re-measured once the display face swaps in and the heading
    // rewraps at its real metrics.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.resize(); });
    }
  }

  /* Format the coordinate lines here rather than in Liquid, which has no
     fixed-decimal filter and would render "38.0" where the label wants
     "38.00". Liquid still prints a rounded fallback for the no-JS case. */
  CorkMap.prototype.writeCoords = function () {
    var pairs = [['origin', this.origin], ['dest', this.dest]], i;
    for (i = 0; i < pairs.length; i++) {
      var el = this.root.querySelector('.cork-map__pin--' + pairs[i][0] + ' .cork-map__pin-coords');
      if (!el) continue;
      var p = pairs[i][1];
      el.textContent =
        Math.abs(p.lat).toFixed(2) + '°' + (p.lat < 0 ? 'S' : 'N') + ' ' +
        Math.abs(p.lon).toFixed(2) + '°' + (p.lon < 0 ? 'W' : 'E');
    }
  };

  /* Fit --------------------------------------------------------------------
     Scale is always driven by width. Cropping horizontally would push an
     endpoint off frame, which is the one thing this hero cannot do. Vertical
     slack is absorbed instead: overflow is trimmed mostly off the top (the
     US interior and Canada carry the least meaning here), and spare room is
     left mostly at the bottom, under the copy. */
  CorkMap.prototype.resize = function () {
    var rect = this.root.getBoundingClientRect();
    var w = Math.max(1, Math.round(rect.width));
    var h = Math.max(1, Math.round(rect.height));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    this.w = w;
    this.h = h;
    this.dpr = dpr;
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    this.canvas.style.width = w + 'px';
    this.canvas.style.height = h + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    this.scale = w / PROJ_W;
    var slack = h - PROJ_H * this.scale;

    /* Overflow is always trimmed mostly off the top — the US interior and
       Canada carry the least meaning here.

       Surplus is the interesting case, and the two layouts want opposite
       things. With the copy inset into the map (>=1200px) any gap left at the
       bottom shows up as a blank strip beside the button, so the map is
       anchored flush to the bottom and the slack becomes breathing room under
       the header instead. In the stacked layout the copy sits below the map,
       so the same move would drop the Caribbean straight onto the headline —
       there the map stays near the top. */
    if (slack < 0) {
      this.dy = slack * 0.62;
    } else if (this.inset()) {
      this.dy = slack;
    } else {
      this.dy = Math.min(slack * 0.10, 28);
    }

    this.measureCopy();
    this.avoidContent();

    // Keep dots at a readable pitch on every screen by thinning the grid
    // rather than shrinking the dots into mush.
    var pitch = w / GRID.cols;
    this.step = Math.max(1, Math.round(4.4 / pitch));
    this.radius = Math.min(1.9, Math.max(0.65, pitch * this.step * 0.32));
    // Uncovered dots sit on a coarser grid, so they carry a little more weight
    // than the map's own without ever out-massing a coastline.
    this.fieldRad = Math.max(1.45, this.radius * 1.3);

    // The lattice buildLand walks, in canvas px, so the cursor field can walk
    // the same one without rederiving it from latitudes per dot.
    this.cellW = PROJ_W * this.scale / GRID.cols;
    this.cellH = PROJ_H * this.scale / GRID.rows;

    this.buildGrove();
    this.buildLand();
    this.placePins();
    this.render();
  };

  /* Keep the route off the headline ---------------------------------------
     The copy is bottom-anchored, so as the hero gets shorter or the heading
     wraps to another line the text climbs toward the descending Florida leg
     of the arc. Tuning percentages by hand only ever fixes one viewport, so
     measure it: find the deepest the route dips into the content box and
     lift the whole map by exactly that much.

     Lifting is bounded by the destination pin, which has to keep room above
     it for the frame edge and below it for its label. If the bound bites,
     the hero is too short for its copy and the CSS min-heights are the
     thing to change. */
  /* Where the copy sits, in canvas coordinates. Both the route clearance and
     the grove clearing are cut from this one measurement. */
  CorkMap.prototype.measureCopy = function () {
    var content = this.root.parentNode &&
      this.root.parentNode.querySelector('.cork-map-hero__content');
    this.copyBox = null;
    if (!content) return;

    var box = content.getBoundingClientRect();
    var base = this.root.getBoundingClientRect();
    if (!box.width || !box.height) return;

    this.copyBox = {
      left: box.left - base.left,
      right: box.right - base.left,
      top: box.top - base.top
    };
  };

  CorkMap.prototype.avoidContent = function () {
    if (!this.copyBox) return;
    var left = this.copyBox.left - 18;
    var right = this.copyBox.right + 18;
    var top = this.copyBox.top - 18;

    var r = this.route, i, x, y, need = 0;
    for (i = 0; i < r.length; i++) {
      x = this.px(r[i].lon);
      if (x < left || x > right) continue;
      y = this.py(r[i].lat);
      if (y > top) need = Math.max(need, y - top);
    }
    if (!need) return;

    var destTop = (GRID.latMax - this.dest.lat) * this.scale;
    var minDy = 62 - destTop;
    this.dy = Math.max(minDy, this.dy - need);
  };

  /* True when the copy is inset into the map rather than stacked beneath it.
     Must stay in step with the 1200px breakpoint in cork-map.css. */
  CorkMap.prototype.inset = function () {
    return !window.matchMedia || window.matchMedia('(min-width: 1200px)').matches;
  };

  CorkMap.prototype.px = function (lon) { return (lon - GRID.lonMin) * K * this.scale; };
  CorkMap.prototype.py = function (lat) { return (GRID.latMax - lat) * this.scale + this.dy; };

  /* The land layer is ~20,000 dots. Painting it every frame would make the
     pulse cost more than the rest of the page combined, so it is rasterised
     once per resize into an offscreen canvas and blitted after that. */
  CorkMap.prototype.buildLand = function () {
    var layer = this.layer || (this.layer = document.createElement('canvas'));
    layer.width = this.canvas.width;
    layer.height = this.canvas.height;
    var ctx = layer.getContext('2d');
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

    // Dots lift toward full strength near the two endpoints. Reads as a
    // focus falloff rather than an effect, and puts the eye on Portugal and
    // Florida instead of on the middle of Kansas.
    var ox = this.px(this.origin.lon), oy = this.py(this.origin.lat);
    var dx = this.px(this.dest.lon), dy = this.py(this.dest.lat);
    var focus = this.w * 0.11;
    var c = this.dotColor;
    var i, j, x, y, lat;

    for (j = 0; j < GRID.rows; j += this.step) {
      lat = GRID.latMax - (j + 0.5) * PROJ_H / GRID.rows;
      y = this.py(lat);
      if (y < -4 || y > this.h + 4) continue;

      for (i = 0; i < GRID.cols; i += this.step) {
        if (!LAND[j * GRID.cols + i]) continue;
        x = ((i + 0.5) / GRID.cols) * PROJ_W * this.scale;

        var near = Math.max(0, 1 - Math.min(
          Math.sqrt((x - ox) * (x - ox) + (y - oy) * (y - oy)),
          Math.sqrt((x - dx) * (x - dx) + (y - dy) * (y - dy))
        ) / focus);

        ctx.fillStyle = rgba(c, (0.34 + 0.32 * near * near).toFixed(3));
        ctx.beginPath();
        ctx.arc(x, y, this.radius, 0, 6.2832);
        ctx.fill();
      }
    }
  };

  /* The montado ------------------------------------------------------------
     A stand of cork oaks across the open Atlantic — the empty white middle of
     the frame, between the American coast and Iberia. It is a deliberate
     conceit rather than a mistake of geography: the sea is the one part of
     the composition with nothing in it, and filling it with the tree the
     whole business depends on says "source" better than more ocean does.

     Seven ranks recede from a ground line on the section's bottom rule. Every
     tree, near and far, is stippled on the same lattice the landmass uses —
     the grove is made of the map's own material, not pasted over it. Depth is
     carried by four things at once: size, tone, dot radius, and where the
     tree meets the ground. The front rank resolves into a near-solid treeline
     because its dots are wide enough to touch; the back ranks dissolve into
     haze because theirs are not.

     Bounds are the coastlines: the grove starts east of Florida and stops
     west of Portugal, so it never sits on top of the dotted land.

     Output is three banded layers rather than one bake, because they sway —
     see drawGrove(). */
  CorkMap.prototype.buildGrove = function () {
    this.grove = null;
    // Where the treeline starts, for the cursor field to fade out over. Equal
    // values mean no grove, and no fade.
    this.groundY = this.groveTop = this.h;
    if (this.w < 380) return;

    /* The trees stand on the section's own bottom rule. Rooting them below
       the edge instead crops the trunk, and the trunk is where the harvest
       line lives — the one mark that says cork oak rather than oak. */
    var frameBottom = this.dy + PROJ_H * this.scale;
    var groundY = Math.min(this.h - 1, frameBottom);
    var c = this.dotColor;
    var unit = Math.min(this.h, this.w * 0.40);

    // Open water, in canvas x: clear of the Florida coast on one side and the
    // Moroccan coast on the other, so the grove never stands on dotted land.
    var seaL = this.px(-76);
    var seaR = this.px(-22);
    var span = seaR - seaL;
    if (span < unit * 0.6) return;

    this.groundY = groundY;
    this.groveTop = groundY - unit * 0.30;

    /* `lift` raises the ground line for the further ranks. This is the cue
       that carries the whole illusion, and it has to be large — larger than
       feels right on paper. A first pass used small lifts, and every rank
       ended up occupying the same vertical band as the near canopy, fully
       occluded by it: seven ranks of detail contributing nothing but
       darkness, and the grove came out as one solid blot from the ground
       line to the headline. Lifted properly, each rank crests just above the
       one in front and the stand reads as scalloped depth.

       `dotK` is the dot radius as a fraction of the lattice pitch: at 0.50
       the dots touch and the rank reads as a silhouette, at 0.26 they stay
       separate and it reads as haze.

       Every scattered rank is capped so its crest lands around 0.20 units —
       roughly a fifth of the band — which puts the whole distant stand below
       the last line of body copy. That ceiling is the thing keeping the type
       on clean paper: with it, the copy needs almost no help from the dim,
       and without it no amount of dimming looks like anything but an erased
       stripe through the middle of the ocean.

       The scattered ranks are also densely enough planted to close up
       laterally. Below the ceiling a tree is too small for its trunk to
       survive the lattice, so an isolated one is just a crown — a pale round
       blob, which is to say a cloud, which is the failure this whole grove
       has always been one step away from. Merged into a continuous scalloped
       band they read as a treeline instead, and a treeline is what distance
       actually looks like.

       The last rank is the front plane, and it is two trees, placed by
       longitude because that is what they are: one standing off the Bahamas,
       one in open water short of Morocco. They flank the copy rather than
       sitting behind it. That is a hard requirement — the block is 670px wide
       at desktop and a hero crown is 400, so a hero tree anywhere inside it
       has to be dimmed to nothing. An earlier pass put four across the span
       and the two central ones were erased outright, while the outer two took
       the dim gradient across their crowns as a left-to-right wash. Out here
       they stay whole.

       The western one is the smaller of the two, and sits at -75 rather than
       hard against the Florida coast, because at 0.80 it is darker than the
       land dots painted over it — so a crown any further west stops reading
       as a tree behind Florida and starts reading as Florida missing. The
       peninsula is the one thing this hero exists to show.

       A montado is a savanna, not a forest — spacing is the species. */
    var RANKS = [
      { n: 30, hMin: 0.026, hMax: 0.040, alpha: 0.13, jitter: 0.85, lift: 0.158, dotK: 0.26 },
      { n: 24, hMin: 0.038, hMax: 0.055, alpha: 0.14, jitter: 0.80, lift: 0.130, dotK: 0.28 },
      { n: 18, hMin: 0.055, hMax: 0.078, alpha: 0.17, jitter: 0.72, lift: 0.100, dotK: 0.31 },
      { n: 14, hMin: 0.078, hMax: 0.105, alpha: 0.20, jitter: 0.64, lift: 0.068, dotK: 0.35 },
      { n: 10, hMin: 0.100, hMax: 0.135, alpha: 0.26, jitter: 0.55, lift: 0.036, dotK: 0.40 },
      { n:  7, hMin: 0.135, hMax: 0.195, alpha: 0.36, jitter: 0.45, lift: 0.010, dotK: 0.45 },
      {
        atLon: [-75.0, -21.0],
        hAt:   [0.340, 0.450],
        alpha: 0.80, lift: 0.000, dotK: 0.50
      }
    ];

    /* Ranks are banded into three layers so they can sway at three different
       phases and amplitudes. One layer per rank would be truer but costs
       seven full-width canvases; one layer for the lot would make the whole
       forest lean in unison, which is the thing that reads as fake.

       `dim` is how far the layer steps back behind the copy. It is per layer
       rather than per rank because what the type sits on is the accumulated
       tone of everything behind it, not any one rank's — seven ranks each
       capped at a polite 0.16 still stack past 0.5. It stays gentle here
       because the rank ceiling already does the real work: nothing but the
       button is sitting on the grove, and the button is opaque. This is only
       enough to keep an edge under it. */
    var GROUPS = [
      { ranks: [0, 1, 2], amp: 0.008, phase: 0.0, dim: 0.30 },
      { ranks: [3, 4],    amp: 0.013, phase: 2.3, dim: 0.38 },
      { ranks: [5, 6],    amp: 0.019, phase: 4.6, dim: 0.55 }
    ];

    var rnd = mulberry32(20260724);
    var copy = this.inset() ? this.copyBox : null;
    var pitch = Math.max(3.2, (this.w / GRID.cols) * this.step);
    var r, k, rank, n, x, h;

    /* Every tree is generated up front, in rank order, off one seeded stream.
       The grove has to come out identical on every load and every resize —
       one that reshuffles on rotate reads as a bug — so nothing downstream is
       allowed to draw from `rnd`. */
    var trees = [];
    for (r = 0; r < RANKS.length; r++) {
      rank = RANKS[r];
      trees[r] = [];
      n = rank.atLon ? rank.atLon.length : rank.n;
      for (k = 0; k < n; k++) {
        // Even spacing with jitter. A montado is planted on a grid and then
        // grows out of it; pure scatter reads as noise, a hard grid reads as
        // an orchard.
        if (rank.atLon) {
          x = this.px(rank.atLon[k]);
          h = unit * rank.hAt[k];
        } else {
          x = seaL + span * ((k + 0.5) / n) + (rnd() - 0.5) * (span / n) * rank.jitter;
          h = unit * (rank.hMin + rnd() * (rank.hMax - rank.hMin));
        }
        trees[r].push({ x: x, tree: corkOak(rnd, h) });
      }
    }

    /* Each rank is drawn opaque into a scratch buffer and blitted once at the
       rank's tone. Painting the trees straight on at partial alpha makes
       every overlap compound, which turned a cluster on the Moroccan side
       into a single dark blot. Within a rank the trees are the same distance
       away, so they should read as one tone no matter how they overlap;
       between ranks the compounding is the depth cue and is kept. */
    var scratch = document.createElement('canvas');
    var groups = [], gi, i, gcv, gctx, sctx, top, bot, bh;

    for (gi = 0; gi < GROUPS.length; gi++) {
      var G = GROUPS[gi];

      // Band the layer to just the strip its trees occupy. Full-frame layers
      // would be three times the memory for the same picture.
      top = groundY;
      for (i = 0; i < G.ranks.length; i++) {
        rank = RANKS[G.ranks[i]];
        top = Math.min(top, groundY - unit * (rank.lift + tallest(rank) * 1.18));
      }
      top = Math.max(0, Math.floor(top) - 2);
      bot = Math.min(this.h, Math.ceil(groundY) + 2);
      bh = bot - top;
      if (bh <= 0) continue;

      gcv = document.createElement('canvas');
      gcv.width = Math.max(1, Math.round(this.w * this.dpr));
      gcv.height = Math.max(1, Math.round(bh * this.dpr));
      gctx = gcv.getContext('2d');

      if (scratch.width !== gcv.width || scratch.height !== gcv.height) {
        scratch.width = gcv.width;
        scratch.height = gcv.height;
      }
      sctx = scratch.getContext('2d');

      for (i = 0; i < G.ranks.length; i++) {
        rank = RANKS[G.ranks[i]];

        sctx.setTransform(1, 0, 0, 1, 0, 0);
        sctx.clearRect(0, 0, scratch.width, scratch.height);
        sctx.setTransform(this.dpr, 0, 0, this.dpr, 0, -top * this.dpr);

        var rankGround = groundY - unit * rank.lift;
        var rad = Math.max(0.55, pitch * rank.dotK);
        for (k = 0; k < trees[G.ranks[i]].length; k++) {
          this.paintDottedTree(sctx, trees[G.ranks[i]][k].tree,
            trees[G.ranks[i]][k].x, rankGround, c, rad);
        }

        gctx.save();
        gctx.globalAlpha = rank.alpha;
        gctx.setTransform(1, 0, 0, 1, 0, 0);
        gctx.drawImage(scratch, 0, 0);
        gctx.restore();
      }

      /* Behind the copy the layer steps back rather than clearing out. A hole
         in the grove shaped exactly like the text block would be far more
         obvious than a soft dimming, so this is a gradient with generous
         feathering, not a cut-out. The feather is wide enough that the front
         plane's outermost trees have their inner halves fade under the
         headline while their outer halves stay full — the tree reads as
         standing behind the type rather than being erased by it. */
      if (copy) {
        var fade = Math.max(80, unit * 0.155);
        gctx.setTransform(this.dpr, 0, 0, this.dpr, 0, -top * this.dpr);
        var g = gctx.createLinearGradient(copy.left - fade, 0, copy.right + fade, 0);
        var w1 = fade / (copy.right - copy.left + fade * 2);
        var cut = G.dim.toFixed(3);
        g.addColorStop(0, 'rgba(0,0,0,0)');
        g.addColorStop(Math.min(0.49, w1), 'rgba(0,0,0,' + cut + ')');
        g.addColorStop(Math.max(0.51, 1 - w1), 'rgba(0,0,0,' + cut + ')');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        gctx.globalCompositeOperation = 'destination-out';
        gctx.fillStyle = g;
        gctx.fillRect(copy.left - fade, top, (copy.right - copy.left) + fade * 2, bh);
        gctx.globalCompositeOperation = 'source-over';
      }

      /* Aerial perspective on the farthest band only: crowns thin out toward
         their tops, the way a treeline does at distance. Applied to the whole
         band rather than per tree, so it is a property of the air rather than
         of any one crown. */
      if (gi === 0) {
        gctx.setTransform(1, 0, 0, 1, 0, 0);
        var hz = gctx.createLinearGradient(0, 0, 0, gcv.height * 0.45);
        hz.addColorStop(0, 'rgba(0,0,0,0.16)');
        hz.addColorStop(1, 'rgba(0,0,0,0)');
        gctx.globalCompositeOperation = 'destination-out';
        gctx.fillStyle = hz;
        gctx.fillRect(0, 0, gcv.width, gcv.height);
        gctx.globalCompositeOperation = 'source-over';
      }

      groups.push({
        canvas: gcv, y: top, h: bh, ground: groundY,
        amp: G.amp, phase: G.phase
      });
    }

    // The scratch is the single biggest allocation here and is dead the
    // moment the last band is composited.
    scratch.width = scratch.height = 0;
    this.grove = groups.length ? groups : null;
  };

  /* Trees are dots on the same lattice the land uses, so the grove appears to
     be made of the same material as the map. The lattice is global rather
     than tree-local, so neighbouring trees and the landmass behind them share
     one grid and the whole hero reads as one halftone. */
  CorkMap.prototype.paintDottedTree = function (ctx, tree, ox, groundY, color, rad) {
    var pitch = Math.max(3.2, (this.w / GRID.cols) * this.step);
    var halfW = tree.crownW * 0.72;
    var x, y, gx, gy, rr;

    /* The harvest line. On a stripped cork oak the trunk below the cut is
       bare wood and reads noticeably lighter than the bark above it, with a
       hard horizontal boundary. In dots that is a step down in radius rather
       than a change of tone — and it is the single mark that identifies the
       species, so it is worth being legible rather than tasteful. */
    var harvest = groundY - tree.harvestY;
    var bare = rad * 0.68;

    ctx.fillStyle = rgba(color, 1);

    var x0 = Math.ceil((ox - halfW) / pitch) * pitch;
    var y1 = groundY;
    var y0 = groundY - tree.h * 1.12;

    for (gy = Math.ceil(y0 / pitch) * pitch; gy <= y1; gy += pitch) {
      if (gy < -pitch || gy > this.h + pitch) continue;
      rr = gy > harvest ? bare : rad;
      for (gx = x0; gx <= ox + halfW; gx += pitch) {
        x = gx - ox;
        y = groundY - gy;
        if (!inTree(tree, x, y)) continue;
        ctx.beginPath();
        ctx.arc(gx, gy, rr, 0, 6.2832);
        ctx.fill();
      }
    }
  };

  /* Wind ---------------------------------------------------------------------
     Each band is sheared about the ground line, so the trunks stay planted
     and displacement grows with height — which is what a tree actually does.
     Amplitude and phase differ per band, so the near stand leads the far one
     and the forest never leans as a single object.

     A shear on three pre-composited bands is the whole per-frame cost: three
     drawImage calls. Swaying trees individually would mean recompositing the
     ranks every frame, and the ranks exist precisely because compositing them
     is expensive. */
  CorkMap.prototype.drawGrove = function () {
    var g = this.grove;
    if (!g) return;
    var ctx = this.ctx, t = this.tNow || 0, i, b, s;

    for (i = 0; i < g.length; i++) {
      b = g[i];
      s = 0;
      if (!reduceMotion) {
        // A long carrier with a shorter harmonic on top. One sine alone reads
        // as a metronome; the second breaks the period without speeding it up.
        s = b.amp * (0.72 * Math.sin(t / 19000 * 6.2832 + b.phase) +
                     0.28 * Math.sin(t / 7300 * 6.2832 + b.phase * 1.7));
      }
      ctx.save();
      ctx.translate(0, b.ground);
      ctx.transform(1, 0, s, 1, 0, 0);
      ctx.translate(0, -b.ground);
      ctx.drawImage(b.canvas, 0, 0, b.canvas.width, b.canvas.height,
        0, b.y, this.w, b.h);
      ctx.restore();
    }
  };

  CorkMap.prototype.placePins = function () {
    var pins = [['origin', this.origin], ['dest', this.dest]], i;
    for (i = 0; i < pins.length; i++) {
      var el = this.root.querySelector('.cork-map__pin--' + pins[i][0]);
      if (!el) continue;
      el.style.left = this.px(pins[i][1].lon).toFixed(1) + 'px';
      el.style.top = this.py(pins[i][1].lat).toFixed(1) + 'px';
    }
  };

  /* Pointer ----------------------------------------------------------------
     Listened on the section rather than the window: the canvas is
     pointer-events: none and the copy block sits above it, so the section is
     the only node that sees the pointer everywhere in the hero.

     Touch is ignored. There is no hover on a phone, and a finger dragging the
     page would light the field up under the scroll, which reads as a bug. */
  CorkMap.prototype.watchPointer = function () {
    if (reduceMotion || !window.PointerEvent) return;
    var host = this.root.parentNode;
    if (!host) return;
    var c = this.cursor;

    host.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      c.tx = e.clientX;
      c.ty = e.clientY;
      c.on = true;
    }, { passive: true });

    host.addEventListener('pointerleave', function () {
      // Forget where it was, so a pointer that re-enters somewhere else does
      // not drag the bulge across the whole hero to catch up.
      c.on = false;
      c.seen = false;
      c.lx = c.ly = -9999;
    });
  };

  CorkMap.prototype.updateCursor = function () {
    var c = this.cursor;
    if (!c.on && !c.engage) return;

    var r = this.root.getBoundingClientRect();
    var tx = c.tx - r.left, ty = c.ty - r.top;

    /* Pointer speed in px per frame, smoothed — the same gate the reference
       component uses. The field is a response to movement, not to presence.

       The floor is ours. Decaying all the way to nothing means the hero goes
       dead the moment someone stops to read it, or rests the mouse on the
       button, which is most of the time they are here. */
    var d = Math.sqrt((tx - c.lx) * (tx - c.lx) + (ty - c.ly) * (ty - c.ly));
    if (c.lx < -9000) d = 0;
    c.lx = tx; c.ly = ty;
    c.speed += (d - c.speed) * 0.35;

    var want = c.on ? Math.min(1, 0.25 + c.speed / 4) : 0;
    c.engage += (want - c.engage) * 0.07;
    if (c.engage < 0.002) c.engage = 0;

    if (!c.seen) { c.x = tx; c.y = ty; c.seen = true; }
    c.x += (tx - c.x) * 0.20;
    c.y += (ty - c.y) * 0.20;
  };

  /* Walks the same lattice buildLand does, over the disc under the pointer.
     Land cells are the map's own dots, redrawn displaced and a little
     brighter; empty cells are ocean, and those are the ones being uncovered.

     Two things are held back deliberately. The uncovered dots fade out over
     the grove, because a stand of trees is an object and dots crawling across
     a silhouette read as dirt on it — the land dots there still move, so the
     Caribbean responds where the trees do not. And they fade behind the copy,
     on the same feathered ramp the grove uses, so the pointer cannot push a
     field of dots up behind the headline. */
  CorkMap.prototype.drawField = function () {
    var ctx = this.ctx, c = this.cursor;
    var eng = c.engage, cx = c.x, cy = c.y;
    var R = FIELD_R, R2 = R * R;
    var step = this.step, cw = this.cellW, ch = this.cellH;

    var i0 = Math.max(0, Math.floor((cx - R) / cw - 0.5));
    var i1 = Math.min(GRID.cols - 1, Math.ceil((cx + R) / cw - 0.5));
    var j0 = Math.max(0, Math.floor((cy - R - this.dy) / ch - 0.5));
    var j1 = Math.min(GRID.rows - 1, Math.ceil((cy + R - this.dy) / ch - 0.5));
    i0 = Math.ceil(i0 / step) * step;
    j0 = Math.ceil(j0 / step) * step;

    var ox = this.px(this.origin.lon), oy = this.py(this.origin.lat);
    var ex = this.px(this.dest.lon), ey = this.py(this.dest.lat);
    var focus = this.w * 0.11;

    var copy = this.inset() ? this.copyBox : null;
    var cfade = 90;
    var gTop = this.groveTop, gRun = this.groundY - gTop;

    /* `x`/`y` are the dot's anchor and stay untouched; `ux`/`uy` are where it
       gets drawn. Displacing the loop variables instead lets the vertical
       push accumulate along a row — every dot inheriting the drift of the one
       before it — which comes out as the whole field curling into arcs. */
    var bk = this.bucket;
    var i, j, jc, x, y, ux, uy, dx, dy, d2, d, t, a, push, veil, edge, near, b;

    /* Pass one: the map's own dots, on the map's own lattice. Only the land
       cells — the ocean ones have nothing baked under them to replace. */
    for (j = j0; j <= j1; j += step) {
      y = this.dy + (j + 0.5) * ch;
      dy = y - cy;
      jc = j * GRID.cols;

      for (i = i0; i <= i1; i += step) {
        if (!LAND[jc + i]) continue;
        x = (i + 0.5) * cw;
        dx = x - cx;
        d2 = dx * dx + dy * dy;
        if (d2 > R2) continue;
        d = Math.sqrt(d2);
        t = 1 - d / R;

        near = Math.max(0, 1 - Math.min(
          Math.sqrt((x - ox) * (x - ox) + (y - oy) * (y - oy)),
          Math.sqrt((x - ex) * (x - ex) + (y - ey) * (y - ey))
        ) / focus);
        a = 0.34 + 0.32 * near * near + FIELD_BOOST * t * eng;
        if (a > 0.96) a = 0.96;

        /* Away from the pointer, hardest at the centre. Same falloff as the
           reference: t squared, so displacement reaches zero at the rim and
           the live dots meet the baked layer with nothing to give the seam
           away. */
        push = t * t * FIELD_PUSH * eng;
        ux = x; uy = y;
        if (d > 0.001) { ux += dx / d * push; uy += dy / d * push; }

        b = (a * FIELD_BUCKETS / 0.96) | 0;
        if (b > FIELD_BUCKETS - 1) b = FIELD_BUCKETS - 1;
        bk[b].push(ux, uy);
      }
    }
    this.flush(this.radius);

    /* Pass two: the ocean, on the coarse grid, uncovered rather than moved
       aside — there is nothing there at rest. */
    var cstep = step * FIELD_STEP;
    i0 = Math.ceil(i0 / cstep) * cstep;
    j0 = Math.ceil(j0 / cstep) * cstep;

    for (j = j0; j <= j1; j += cstep) {
      y = this.dy + (j + 0.5) * ch;
      dy = y - cy;
      jc = j * GRID.cols;

      // Over the treeline the field fades out entirely. A stand of trees is
      // an object, and dots crawling across a silhouette read as dirt on it.
      veil = 1;
      if (gRun > 0 && y > gTop) {
        veil = 1 - (y - gTop) / gRun;
        if (veil < 0) veil = 0;
      }
      if (!veil) continue;

      // Behind the copy it steps back rather than off, on a ramp feathered in
      // both axes — a hard vertical cut at the top of the text block was
      // plainly visible as a seam through the middle of the disc.
      edge = 0;
      if (copy) {
        edge = (y - (copy.top - 80)) / 80;
        if (edge < 0) edge = 0; else if (edge > 1) edge = 1;
      }

      for (i = i0; i <= i1; i += cstep) {
        if (LAND[jc + i]) continue;
        x = (i + 0.5) * cw;
        dx = x - cx;
        d2 = dx * dx + dy * dy;
        if (d2 > R2) continue;
        d = Math.sqrt(d2);
        t = 1 - d / R;

        a = FIELD_REVEAL * t * eng * veil;
        if (edge && x > copy.left - cfade && x < copy.right + cfade) {
          var hx = Math.min(x - (copy.left - cfade), (copy.right + cfade) - x) / cfade;
          if (hx > 1) hx = 1;
          a *= 1 - 0.72 * hx * edge;
        }
        if (a <= 0.02) continue;
        if (a > 0.96) a = 0.96;

        push = t * t * FIELD_PUSH * eng;
        ux = x; uy = y;
        if (d > 0.001) { ux += dx / d * push; uy += dy / d * push; }

        b = (a * FIELD_BUCKETS / 0.96) | 0;
        if (b > FIELD_BUCKETS - 1) b = FIELD_BUCKETS - 1;
        bk[b].push(ux, uy);
      }
    }
    this.flush(this.fieldRad);
  };

  // One filled path per tone, rather than one per dot: a frame is sixteen
  // fills instead of several thousand fillStyle strings.
  CorkMap.prototype.flush = function (rad) {
    var ctx = this.ctx, bk = this.bucket, b, arr, k;
    for (b = 0; b < FIELD_BUCKETS; b++) {
      arr = bk[b];
      if (!arr.length) continue;
      ctx.fillStyle = this.fieldColor[b];
      ctx.beginPath();
      for (k = 0; k < arr.length; k += 2) {
        // moveTo before each arc, or consecutive dots get joined by a line.
        ctx.moveTo(arr[k] + rad, arr[k + 1]);
        ctx.arc(arr[k], arr[k + 1], rad, 0, 6.2832);
      }
      ctx.fill();
      arr.length = 0;
    }
  };

  /* Grove first, land over the top. The map is the near plane: where a crown
     runs past a coastline the dots read in front of it and the tree falls
     away behind. Painting the grove last put trees on top of Cuba.

     Where the pointer is, the baked land layer is blitted with that disc
     clipped out and the dots inside it are drawn live instead. At engage 0
     the live pass reproduces the baked one exactly — same lattice, same
     radius, same alpha formula, zero displacement — so there is no transition
     to hide. */
  CorkMap.prototype.render = function () {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.w, this.h);
    this.drawGrove();

    if (this.layer) {
      if (this.cursor.engage) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(0, 0, this.w, this.h);
        ctx.arc(this.cursor.x, this.cursor.y, FIELD_R, 0, 6.2832, true);
        ctx.clip();
        ctx.drawImage(this.layer, 0, 0, this.w, this.h);
        ctx.restore();
        this.drawField();
      } else {
        ctx.drawImage(this.layer, 0, 0, this.w, this.h);
      }
    }

    this.drawRoute();
  };

  CorkMap.prototype.drawRoute = function () {
    var ctx = this.ctx, r = this.route, n = r.length, i;
    var a = this.arcColor;
    var end = Math.max(1, Math.floor((n - 1) * this.progress));

    // Faint dashed guide across the full crossing, so the route reads as a
    // fixed shipping lane the stroke travels along rather than a line
    // growing out of nowhere.
    ctx.strokeStyle = rgba(a, 0.18);
    ctx.lineWidth = 1;
    ctx.setLineDash([2, 5]);
    ctx.beginPath();
    for (i = 0; i < n; i++) {
      ctx[i ? 'lineTo' : 'moveTo'](this.px(r[i].lon), this.py(r[i].lat));
    }
    ctx.stroke();
    ctx.setLineDash([]);

    // Solid leg, drawn origin -> destination.
    ctx.strokeStyle = rgba(a, 0.92);
    ctx.lineWidth = 1.6;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    for (i = 0; i <= end; i++) {
      ctx[i ? 'lineTo' : 'moveTo'](this.px(r[i].lon), this.py(r[i].lat));
    }
    ctx.stroke();

    this.drawEndpoint(this.origin, true);
    this.drawEndpoint(this.dest, this.progress > 0.985);

    if (this.progress >= 1 && !reduceMotion && this.pulse > 0) this.drawPulse();
    if (this.progress >= 1 && !reduceMotion && this.burst > 0) this.drawFan();
  };

  /* The ring is always there — it marks the destination as a target the
     route is heading for, so the Madison label is never left captioning bare
     ocean during the draw-in. The filled dot is the arrival. */
  CorkMap.prototype.drawEndpoint = function (p, arrived) {
    var ctx = this.ctx, a = this.arcColor;
    var x = this.px(p.lon), y = this.py(p.lat);
    ctx.strokeStyle = rgba(a, arrived ? 0.32 : 0.2);
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(x, y, 7.5, 0, 6.2832);
    ctx.stroke();
    ctx.fillStyle = rgba(a, arrived ? 1 : 0.28);
    ctx.beginPath();
    ctx.arc(x, y, arrived ? 3.1 : 2, 0, 6.2832);
    ctx.fill();
  };

  /* A shipment running the lane on a loop. The tail is a short run of real
     route segments behind the head, so it fades along the true curve rather
     than along a straight chord. */
  CorkMap.prototype.drawPulse = function () {
    var ctx = this.ctx, r = this.route, n = r.length, a = this.arcColor;
    var head = this.pulse * (n - 1);
    var tail = 44, i, f;

    ctx.lineCap = 'round';
    for (i = 0; i < tail; i++) {
      var i0 = Math.floor(head - i);
      var i1 = i0 - 1;
      if (i1 < 0) break;
      f = 1 - i / tail;
      ctx.strokeStyle = rgba(a, (f * f * 0.85).toFixed(3));
      ctx.lineWidth = 2.4 * f + 0.5;
      ctx.beginPath();
      ctx.moveTo(this.px(r[i0].lon), this.py(r[i0].lat));
      ctx.lineTo(this.px(r[i1].lon), this.py(r[i1].lat));
      ctx.stroke();
    }

    var hp = r[Math.min(n - 1, Math.max(0, Math.floor(head)))];
    ctx.fillStyle = rgba(a, 1);
    ctx.beginPath();
    ctx.arc(this.px(hp.lon), this.py(hp.lat), 2.7, 0, 6.2832);
    ctx.fill();
  };

  /* The fan-out ============================================================
     The shipment lands at Madison and the country goes out from it: one ray
     per state, leaving the warehouse on its true great-circle bearing.

     Four things here are load-bearing.

     **The frame stops at 100W.** Fifteen of the fifty centroids are outside
     it — the whole mountain west, the Dakotas, plus Alaska and Hawaii — so
     their rays are drawn on the correct bearing and dissolved as they near
     the frame edge instead of being clipped mid-stroke. That reads as the
     country carrying on past the map, which is what is actually happening.
     Widening the frame to hold them is not a local change: `GRID`, the
     `PACKED` mask beside it, `tools/genmask.py`, the 2.2754 aspect in
     cork-map.css and the fallback pin maths in hero-map.liquid all move
     together.

     **Heads run at a constant angular speed, not a constant duration.** A ray
     finishes when its own length is used up, so Georgia lights a beat after
     the shipment lands and California a second later. Give them all the same
     duration instead and fifty dots arrive on the same frame, which reads as
     one pop rather than as distribution.

     **Ink inside the copy block is dimmed, not clipped.** Rays to the
     northeast pass close under the headline. A hole shaped like the text
     block would be far more obvious than a soft dimming — the same reasoning
     that governs the grove. `avoidContent()` is deliberately not involved:
     it lifts the whole map, and lifting the composition for something that
     lasts three seconds and then vanishes would be worse than the problem.

     **Cost is held down the way the cursor field holds it down.** Alpha is
     quantised into buckets and a frame is a handful of paths, not a stroke
     per ray. Fifty rays at one stroke each would be fifty `strokeStyle`
     strings a frame. */

  /* Geographic centres, lat/lon. Alphabetical by state. */
  var STATES = [
    [32.79, -86.83],  [63.35, -152.84], [34.29, -111.66], [34.90, -92.44],
    [37.18, -119.47], [39.00, -105.55], [41.62, -72.73],  [38.99, -75.51],
    [28.63, -82.45],  [32.64, -83.44],  [20.25, -156.37], [44.39, -114.66],
    [40.06, -89.20],  [39.89, -86.28],  [42.07, -93.50],  [38.49, -98.38],
    [37.53, -85.30],  [31.07, -92.00],  [45.37, -69.24],  [39.04, -76.79],
    [42.26, -71.81],  [44.35, -85.41],  [46.28, -94.31],  [32.74, -89.68],
    [38.37, -92.48],  [47.05, -109.63], [41.53, -99.80],  [39.33, -116.63],
    [43.69, -71.58],  [40.19, -74.67],  [34.42, -106.11], [42.95, -75.53],
    [35.54, -79.36],  [47.45, -100.47], [40.29, -82.79],  [35.59, -97.49],
    [43.94, -120.55], [40.87, -77.80],  [41.68, -71.56],  [33.86, -80.90],
    [44.44, -100.23], [35.83, -86.35],  [31.49, -99.34],  [39.34, -111.67],
    [44.07, -72.67],  [37.52, -78.85],  [47.38, -120.45], [38.64, -80.62],
    [44.62, -89.71],  [42.99, -107.55]
  ];

  var FAN_STEPS = 32;      // points per ray
  var FAN_BUCKETS = 10;    // alpha quantisation across the whole burst
  var FAN_REACH = 1 / 0.6; // the longest in-frame ray lands at 60% of the burst
  var FAN_RING = 0.13;     // fraction of the burst an arrival ring lasts
  /* The dissolve is a distance on the *map*, not on the canvas. As a fixed
     74px it was a twentieth of the frame at 1900 and a fifth of it at 390,
     where Madison itself sits 62px from the left edge — so on a phone the
     whole westward half of the burst was being faded out as if it were
     leaving. 3.2 degrees of longitude is the same slice of the world at
     every width. */
  var FAN_EDGE_DEG = 3.2;
  var FAN_W = 1.25;        // px. One width for every trail; alpha does the work.

  /* Feathered on both axes. A hard cut at the top of the text block shows up
     as a seam, the same way it did in the cursor field. */
  CorkMap.prototype.copyDim = function (x, y) {
    var c = this.copyBox;
    if (!c) return 1;
    var F = 46;
    var dx = Math.min(x - (c.left - F), (c.right + F) - x);
    if (dx <= 0) return 1;
    var dy = y - (c.top - F);
    if (dy <= 0) return 1;
    return 1 - 0.88 * Math.min(1, dx / F) * Math.min(1, dy / F);
  };

  /* `fanEdge` is set once a frame in drawFan rather than recomputed here —
     this runs a few hundred times per frame. */
  CorkMap.prototype.edgeFade = function (x, y) {
    var d = Math.min(x, y, this.w - x, this.h - y);
    return d <= 0 ? 0 : Math.min(1, d / this.fanEdge);
  };

  CorkMap.prototype.drawFan = function () {
    var fan = this.fan, nf = fan.length, b = this.burst;
    if (!nf || b <= 0) return;

    /* In over the first sliver, so the burst is not at full strength on the
       same frame the shipment lands; out over the tail, so nothing is still
       lit when the next crossing starts. */
    var env = Math.min(1, b / 0.06) * Math.min(1, (1 - b) / 0.26);
    if (env <= 0.012) return;

    this.fanEdge = Math.max(6, FAN_EDGE_DEG * K * this.scale);

    var reach = b * this.fanMax * FAN_REACH;
    var i, k, ray, pts, n, headI, age, a, f, x, y, px, py, idx;

    for (i = 0; i < nf; i++) {
      ray = fan[i];
      pts = ray.pts;
      n = pts.length - 1;

      age = (reach - ray.ang) / (this.fanMax * FAN_REACH);   // <0 until arrival
      headI = Math.min(n, Math.ceil(Math.min(ray.ang, reach) / ray.ang * n));

      /* The whole travelled path, drawn behind the dot and left in place once
         it lands — the owner's call, "one line should be following each dot".

         The alpha ramps toward the head and the ramp is squared. That is the
         thing holding this together rather than a stylistic flourish: fifty
         lines converge on one point at Madison, and at a flat alpha they
         compound into a solid gold wedge over north Florida. Faint at the hub
         and bright at the head, the convergence stays light, the moving end
         stays legible, and the direction of travel reads without an arrow. */
      px = null;
      for (k = 0; k <= headI; k++) {
        x = this.px(pts[k].lon);
        y = this.py(pts[k].lat);
        if (px !== null) {
          f = headI ? k / headI : 1;
          a = (0.06 + 0.44 * f * f) * env *
              this.edgeFade(x, y) * this.copyDim(x, y);
          if (a > 0.02) {
            idx = Math.min(FAN_BUCKETS - 1, (a * FAN_BUCKETS) | 0);
            this.fanSeg[idx].push(px, py, x, y);
          }
        }
        px = x; py = y;
      }

      // The head, while it is still moving. Once it lands the arrival dot below
      // takes over at the same spot.
      if (age <= 0 && px !== null) {
        a = env * this.edgeFade(px, py) * this.copyDim(px, py);
        if (a > 0.02) {
          idx = Math.min(FAN_BUCKETS - 1, (a * FAN_BUCKETS) | 0);
          this.fanDot[idx].push(px, py);
        }
      }

      /* Landed: a dot that holds until the envelope closes, and a ring that
         opens once. The ring is what makes an arrival read as an arrival —
         without it fifty dots just accumulate. */
      if (age > 0) {
        x = this.px(pts[n].lon);
        y = this.py(pts[n].lat);
        /* A landing is either in the frame or it is not. The soft edge fade
           is for dissolving rays on their way out; applying it to arrivals
           dimmed the states whose centroid happens to sit near the meridian.
           Texas is 0.7deg inside the frame and was landing at a sixth alpha. */
        var vis = (x >= 0 && x <= this.w && y >= 0 && y <= this.h)
          ? this.copyDim(x, y) : 0;
        if (vis > 0) {
          a = env * vis * Math.min(1, age / 0.015);
          if (a > 0.02) {
            idx = Math.min(FAN_BUCKETS - 1, (a * FAN_BUCKETS) | 0);
            this.fanDot[idx].push(x, y);
          }
          if (age < FAN_RING) {
            var rf = age / FAN_RING;
            a = (1 - rf) * 0.5 * env * vis;
            if (a > 0.02) {
              idx = Math.min(FAN_BUCKETS - 1, (a * FAN_BUCKETS) | 0);
              this.fanRing[idx].push(x, y, 2.4 + rf * 8.5);
            }
          }
        }
      }
    }

    this.flushFan();
  };

  CorkMap.prototype.flushFan = function () {
    var ctx = this.ctx, b, arr, k;

    ctx.lineCap = 'round';
    ctx.lineWidth = FAN_W;
    for (b = 0; b < FAN_BUCKETS; b++) {
      arr = this.fanSeg[b];
      if (!arr.length) continue;
      ctx.strokeStyle = this.fanColor[b];
      ctx.beginPath();
      for (k = 0; k < arr.length; k += 4) {
        ctx.moveTo(arr[k], arr[k + 1]);
        ctx.lineTo(arr[k + 2], arr[k + 3]);
      }
      ctx.stroke();
      arr.length = 0;
    }

    for (b = 0; b < FAN_BUCKETS; b++) {
      arr = this.fanDot[b];
      if (!arr.length) continue;
      ctx.fillStyle = this.fanColor[b];
      ctx.beginPath();
      for (k = 0; k < arr.length; k += 2) {
        // moveTo before each arc, or consecutive dots get joined by a line.
        ctx.moveTo(arr[k] + 2, arr[k + 1]);
        ctx.arc(arr[k], arr[k + 1], 2, 0, 6.2832);
      }
      ctx.fill();
      arr.length = 0;
    }

    ctx.lineWidth = 1;
    for (b = 0; b < FAN_BUCKETS; b++) {
      arr = this.fanRing[b];
      if (!arr.length) continue;
      ctx.strokeStyle = this.fanColor[b];
      ctx.beginPath();
      for (k = 0; k < arr.length; k += 3) {
        ctx.moveTo(arr[k] + arr[k + 2], arr[k + 1]);
        ctx.arc(arr[k], arr[k + 1], arr[k + 2], 0, 6.2832);
      }
      ctx.stroke();
      arr.length = 0;
    }
  };

  /* Motion -----------------------------------------------------------------
     Nothing is staged hidden, so a tab that never receives a rAF callback
     still shows a complete hero minus the animation. The watchdog covers the
     inverse case: if the ticker never advances after the section scrolls in,
     snap the route to finished rather than leave it half drawn. */
  CorkMap.prototype.observe = function () {
    var self = this;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      this.progress = 1;
      this.render();
      return;
    }

    new IntersectionObserver(function (entries) {
      var i;
      for (i = 0; i < entries.length; i++) self.visible = entries[i].isIntersecting;
      if (self.visible) self.start();
      else self.stop();
    }, { threshold: 0.12 }).observe(this.root);
  };

  var DRAW_MS = 1700;
  /* Was 5400 for the crossing alone. The crossing still takes ~3.7s; the
     extra 2s is the fan-out plus a beat of dark before the next one. */
  var LOOP_MS = 7400;

  CorkMap.prototype.start = function () {
    if (this.raf) return;
    var self = this;

    if (!this.started) {
      this.started = true;
      this.t0 = null;
      this.watchdog = setTimeout(function () {
        if (self.progress < 1) {
          self.progress = 1;
          self.render();
        }
      }, DRAW_MS + 900);
    }

    function frame(t) {
      if (!self.visible) { self.raf = 0; return; }
      if (self.t0 === null) self.t0 = t;
      var e = t - self.t0;
      self.tNow = e;   // the wind reads off the same clock as the route
      self.updateCursor();

      if (self.progress < 1) {
        if (self.watchdog) { clearTimeout(self.watchdog); self.watchdog = 0; }
        var f = Math.min(1, e / DRAW_MS);
        self.progress = 1 - Math.pow(1 - f, 3); // ease-out cubic
        if (f >= 1) self.progress = 1;
      } else {
        /* Loop with a beat of rest at each end. The shipment lands at 0.58
           and the fan-out picks up from exactly there, so the burst is the
           arrival rather than a separate event that happens near it. */
        var cyc = ((e - DRAW_MS) % LOOP_MS) / LOOP_MS;
        self.pulse = Math.min(1, Math.max(0, (cyc - 0.08) / 0.50));
        self.burst = Math.min(1, Math.max(0, (cyc - 0.58) / 0.40));
      }

      self.render();
      self.raf = requestAnimationFrame(frame);
    }

    this.raf = requestAnimationFrame(frame);
  };

  CorkMap.prototype.stop = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
  };

  function init() {
    var nodes = document.querySelectorAll('[data-cork-map]'), i;
    for (i = 0; i < nodes.length; i++) {
      if (!nodes[i].__corkMap) nodes[i].__corkMap = new CorkMap(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', init);
})();
